import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
// import _ from "lodash";
import { defineComponent, inject } from "vue";
import titleUrl from "@/assets/img/m/homePage/ss-title.png";
import { homePageContextKey } from "@/context/home-page";
// components
import SelectBtn from "@/components/m/common/select-btns.vue";
import Integration from "./integration.vue";
import Eliminated from "./eliminated.vue";
import Championship from "./championship.vue";
// import { groupList } from "@/config/information";
import { raceQuarterOptM, groupTypeOptM, raceTypeOptM } from "@/config/homePage";
export default defineComponent({
  name: "matchProcess",
  setup() {
    const {
      homePageState,
      raceQuarterSwitchFct,
      groupSwitchFct,
      raceTypeSwitchFct
    } = inject(homePageContextKey);
    // 组件状态
    // const onActiveChange = (active) => {
    //   state.activeIndex = active;
    // };

    return () => {
      return _createVNode("div", {
        "class": "content-box"
      }, [_createVNode("div", {
        "class": "title-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": titleUrl
      }, null)]), _createVNode("div", {
        "class": "select-btn"
      }, [_createVNode(SelectBtn, {
        "onClick": raceQuarterSwitchFct,
        "options": raceQuarterOptM,
        "dataValue": homePageState.raceQuartertype,
        "defaultOption": raceQuarterOptM[homePageState.raceQuartertype - 1]
      }, null), _createVNode(SelectBtn, {
        "class": "btn-center",
        "onClick": groupSwitchFct,
        "dataValue": homePageState.groupType,
        "options": groupTypeOptM
      }, null), _createVNode(SelectBtn, {
        "onClick": raceTypeSwitchFct,
        "options": raceTypeOptM,
        "dataValue": homePageState.raceType,
        "defaultOption": raceTypeOptM[homePageState.raceType - 1]
      }, null)]), homePageState.isNone ? _createVNode("div", {
        "class": "none-tips"
      }, [_createTextVNode("\u6682\u65E0\u6570\u636E\uFF0C\u656C\u8BF7\u671F\u5F85")]) : _createVNode("div", null, [homePageState.raceType === 1 && _createVNode(Integration, null, null), homePageState.raceType === 2 && _createVNode(Eliminated, null, null), homePageState.raceType === 3 && _createVNode(Championship, null, null)])]);
    };
  }
});